<!-- section template -->
<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }">
    <el-form
      ref="form"
      :model="FormMixSubmitData"
      label-position="top"
      class="isStyleBase"
      :class="[$style.formInfo, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
      @submit.prevent.native="handleSubmit(onSubmit)"
    >
      <div class="mb-5">
        <ValidationProvider v-slot="{ errors }" name="姓名" rules="require">
          <el-form-item :error="errors[0]" prop="name" label="姓名" class="isRequired">
            <div class="d-flex">
              <div style="flex: 1">
                <el-input v-model="FormMixSubmitData.fullName" placeholder="例：王小明"> </el-input>
              </div>
              <div class="pl-3 pl-md-4" style="flex-shrink: 0">
                <el-radio-group v-model="FormMixSubmitData.gender" class="isStyleBase">
                  <el-radio label="male">先生</el-radio>
                  <el-radio label="female">小姐</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
        </ValidationProvider>
        <el-row :gutter="20">
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="手機號碼">
              <el-form-item :error="errors[0]" prop="shippingInfo.0.phone" label="手機號碼" class="isRequired">
                <el-input v-model="currentMember.phone" placeholder="手機號碼" disabled> </el-input>
              </el-form-item>
            </ValidationProvider>
          </el-col>
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="LINE ID" rules="">
              <el-form-item :error="errors[0]" prop="lineId" label="LINE ID">
                <el-input v-model="FormMixSubmitData.lineId" placeholder="LINE ID"> </el-input>
              </el-form-item>
            </ValidationProvider>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="電子郵件" rules="email">
              <el-form-item :error="errors[0]" prop="email" label="電子郵件(E-mail)">
                <el-input v-model="FormMixSubmitData.email" placeholder="your@email.com"> </el-input>
              </el-form-item>
            </ValidationProvider>
          </el-col>
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="生日" rules="">
              <el-form-item :error="errors[0]" prop="extraInfos.birthday" label="生日">
                <el-date-picker
                  v-model="FormMixSubmitData.extraInfos.birthday"
                  type="date"
                  :editable="false"
                  :clearable="false"
                  :prefix-icon="'none'"
                  format="yyyy/MM/dd"
                  :popper-class="$globalIsDingBeauty ? 'isStyleSquare' : ''"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  :placeholder="`請選擇生日`"
                >
                </el-date-picker>
              </el-form-item>
            </ValidationProvider>
          </el-col>
        </el-row>
      </div>

      <hr />

      <div v-if="$globalIsJtails" class="mb-5 pt-4">
        <div class="layout__header">
          <h2 class="layout__title"> 服務地址 </h2>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="縣市" rules="require">
              <el-form-item :error="errors[0]" prop="shippingInfo.0.city" label="選擇縣市" class="isRequired">
                <el-select v-model="FormMixSubmitData.shippingInfo[0].city" placeholder="請選擇縣市" clearable @change="onChangeCity">
                  <el-option v-for="(city, index) in taiwanCitys" :key="`city-${index}`" :label="city.name" :value="city.name"> </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
          </el-col>
          <el-col :span="12">
            <ValidationProvider v-slot="{ errors }" name="區域" rules="require">
              <el-form-item :error="errors[0]" prop="shippingInfo.0.district" label="選擇區域" class="isRequired">
                <el-select v-model="FormMixSubmitData.shippingInfo[0].district" placeholder="請選擇區域" clearable>
                  <el-option v-for="(district, index) in districts" :key="`district-${index}`" :label="district.name" :value="district.name"> </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
          </el-col>
        </el-row>
        <ValidationProvider v-slot="{ errors }" name="詳細地址" rules="require">
          <el-form-item :error="errors[0]" prop="shippingInfo.0.address" label="詳細地址" class="isRequired">
            <el-input v-model="FormMixSubmitData.shippingInfo[0].address"> </el-input>
          </el-form-item>
        </ValidationProvider>
      </div>

      <hr />

      <!-- 發票 -->
      <div v-if="haveInvoice">
        <BaseSectionTitleJtails v-if="!$globalIsDingBeauty" title="填寫發票資訊" />
        <BaseSectionTitleSecondary v-else title="填寫發票資訊" />
        <!-- 開立類型 -->
        <ValidationProvider v-slot="{ errors }" name="開立類型" rules="require">
          <el-form-item :error="errors[0]" label="開立類型" prop="taxType" class="isRequired">
            <el-select v-model="FormMixSubmitData.taxType" class="is-border" @change="onTaxTypeChange">
              <el-option :value="'B2C'" label="個人"></el-option>
              <el-option :value="'B2B'" label="公司"></el-option>
              <el-option :value="'DONATE'" label="捐贈發票"></el-option>
            </el-select>
          </el-form-item>
        </ValidationProvider>

        <!-- 載具類別 -->
        <ValidationProvider v-if="FormMixSubmitData.taxType === 'B2C'" v-slot="{ errors }">
          <el-form-item :error="errors[0]" label="載具類別" prop="CarrierType" class="isRequired">
            <el-select v-model="FormMixSubmitData.CarrierType" @change="handleCarrierTypeChange">
              <el-option :value="null" label="無（寄送電子發票至客戶 email）"></el-option>
              <el-option :value="'0'" label="手機條碼"></el-option>
              <el-option :value="'1'" label="自然人憑證條碼"></el-option>
              <el-option :value="'2'" label="ezPay 電子發票載具"></el-option>
            </el-select>
          </el-form-item>
        </ValidationProvider>

        <!-- 載具編號 -->
        <ValidationProvider v-if="FormMixSubmitData.taxType === 'B2C' && ['0', '1'].includes(FormMixSubmitData.CarrierType)" v-slot="{ errors }" name="載具編號" rules="require">
          <el-form-item :error="errors[0]" label="載具編號" prop="CarrierNum" class="isRequired">
            <el-input v-model="FormMixSubmitData.CarrierNum" :placeholder="carrierNumExample" class="is-border bg-white"></el-input>
          </el-form-item>
        </ValidationProvider>

        <!-- 統一編號 -->
        <ValidationProvider v-if="FormMixSubmitData.taxType === 'B2B'" v-slot="{ errors }" name="統一編號" rules="require">
          <el-form-item :error="errors[0]" label="統一編號" prop="taxId" class="isRequired">
            <el-input v-model="FormMixSubmitData.taxId" placeholder="請輸入統一編號" class="is-border bg-white"></el-input>
          </el-form-item>
        </ValidationProvider>

        <!-- 捐贈碼 -->
        <ValidationProvider v-if="FormMixSubmitData.taxType === 'DONATE'" v-slot="{ errors }" name="捐贈碼" rules="require">
          <el-form-item :error="errors[0]" label="捐贈碼" prop="LoveCode" class="isRequired">
            <el-input v-model="FormMixSubmitData.LoveCode" placeholder="請輸入捐贈碼">
              <el-link slot="append" target="_blank" href="https://www.einvoice.nat.gov.tw/APCONSUMER/BTC603W/">查詢捐贈碼</el-link>
            </el-input>
          </el-form-item>
        </ValidationProvider>
      </div>

      <BaseLineNotify />

      <div class="row pt-4" :class="{ dingBeautyButtonAlwaysFixed: $globalIsDingBeauty }">
        <div :class="$globalIsDingBeauty ? 'col-6' : 'col-md-6'">
          <BaseButton
            class="isStylePrimary isFull mb-3 mb-md-0"
            :class="{
              'isRadius isOutline3': $globalIsJtails,
              'isOutline isStyleSecondary': $globalIsDingBeauty,
            }"
            @click="$FormMixinOnResetSubmitData"
          >
            取消
          </BaseButton>
        </div>
        <div :class="$globalIsDingBeauty ? 'col-6' : 'col-md-6'">
          <BaseButton
            :disabled="invalid"
            :loading="$isLoading('storeMember')"
            class="isStylePrimary isFull"
            :class="{
              isRadius: $globalIsJtails,
            }"
            type="submit"
          >
            儲存修改
          </BaseButton>
        </div>
      </div>
    </el-form>
    <BasePre>formattedSubmitData: {{ formattedSubmitData }}</BasePre>
    <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
  </ValidationObserver>
</template>

<script>
import store from '@store'
import { messageSuccess } from '@utils/message'
import formMixin from './mixins/form'
import { authComputed } from '@store/helpers'
import { taiwanCitys, districtsFilter, findDistrictZip } from '@utils/address'

const DEFAULT_SUBMIT_DATA = {
  fullName: '',
  gender: 'male',
  phone: '+886-0912345678',
  lineId: '',
  email: '',
  shippingInfo: [
    {
      name: '',
      phone: '',
      city: '',
      district: '',
      address: '',
      postcode: '',
    },
  ],
  extraInfos: {
    birthday: '',
  },
}

export default {
  name:'FormInfo.Jtails',
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'add',
      validator(value) {
        return ['add', 'edit'].includes(value)
      },
    },
  },
  data() {
    return {
      taiwanCitys,
      errorMessage: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date()
        },
      },
    }
  },
  computed: {
    haveInvoice() {
      const merchant = store.state.merchant.currentMerchant || ''
      return merchant.invoiceSetting
    },
    ...authComputed,
    districts() {
      return districtsFilter(this.FormMixSubmitData.shippingInfo[0].city)
    },
    formattedSubmitData() {
      const {
        fullName,
        shippingInfo: [{ city, district, name, ...restShipping }],
        extraInfos: { birthday, ...resExtraInfos },
        ...restData
      } = this.FormMixSubmitData
      return {
        ...restData,
        fullName,
        shippingInfo: [
          {
            ...restShipping,
            city,
            district,
            name: name || fullName,
            postcode: findDistrictZip(city, district),
          },
        ],
        extraInfos: {
          ...resExtraInfos,
          birthday: birthday,
        },
      }
    },
  },
  created() {
    const initFormMixSubmitData = () => {
      const [phonecode, phonenumber] = (this.currentMember.phone || '+886-').split('-')

      this.FormMixSubmitData.fullName = this.currentMember.fullName || DEFAULT_SUBMIT_DATA.fullName
      this.FormMixSubmitData.gender = this.currentMember.gender || DEFAULT_SUBMIT_DATA.gender
      this.FormMixSubmitData.phone = this.currentMember.phone || DEFAULT_SUBMIT_DATA.phone
      this.FormMixSubmitData.lineId = this.currentMember.lineId || DEFAULT_SUBMIT_DATA.lineId
      this.FormMixSubmitData.email = this.currentMember.email || DEFAULT_SUBMIT_DATA.email
      this.FormMixSubmitData.extraInfos = Object.assign({}, this.currentMember?.extraInfos) || DEFAULT_SUBMIT_DATA.extraInfos
      // this.FormMixSubmitData.extraInfos.birthday = this.currentMember.extraInfos.birthday || DEFAULT_SUBMIT_DATA.extraInfos.birthday

      const shippingInfo = this.currentMember?.shippingInfo?.[0] || {}

      this.FormMixSubmitData.shippingInfo[0].name = shippingInfo.name || this.currentMember.fullName || DEFAULT_SUBMIT_DATA.shippingInfo[0].name
      this.FormMixSubmitData.shippingInfo[0].phone = shippingInfo.phone || phonenumber || DEFAULT_SUBMIT_DATA.shippingInfo[0].phone
      this.FormMixSubmitData.shippingInfo[0].city = shippingInfo.city || DEFAULT_SUBMIT_DATA.shippingInfo[0].city
      this.FormMixSubmitData.shippingInfo[0].district = shippingInfo.district || DEFAULT_SUBMIT_DATA.shippingInfo[0].district
      this.FormMixSubmitData.shippingInfo[0].address = shippingInfo.address || DEFAULT_SUBMIT_DATA.shippingInfo[0].address
      this.FormMixSubmitData.shippingInfo[0].postcode = shippingInfo.postcode || DEFAULT_SUBMIT_DATA.shippingInfo[0].postcode

      if (this.haveInvoice) {
        this.FormMixSubmitData.taxType = this.currentMember.taxType
        this.FormMixSubmitData.CarrierType = this.currentMember.CarrierType
        this.FormMixSubmitData.CarrierNum = this.currentMember.CarrierNum
        this.FormMixSubmitData.taxId = this.currentMember.taxId
        this.FormMixSubmitData.LoveCode = this.currentMember.LoveCode
      }
    }

    initFormMixSubmitData()
    this.$FormMixinInitTempSubmitData()
  },
  methods: {
    onTaxTypeChange() {
      this.FormMixSubmitData.CarrierType = ''
      this.FormMixSubmitData.CarrierNum = ''
      this.FormMixSubmitData.taxId = ''
      this.FormMixSubmitData.LoveCode = ''
    },
    handleCarrierTypeChange(newVal) {
      if (newVal == '2' && this.FormMixSubmitData?.phoneNumber) {
        this.FormMixSubmitData.CarrierNum = this.FormMixSubmitData?.phoneNumber
      } else this.FormMixSubmitData.CarrierNum = ''
    },
    onCancel() {
      this.$emit('cancel')
    },
    onSubmit() {
      this.tryToStoreInfo()
    },
    onChangeCity() {
      this.FormMixSubmitData.shippingInfo[0].district = ''
      this.FormMixSubmitData.shippingInfo[0].postcode = ''
    },
    tryToStoreInfo() {
      this.$store
        .dispatch('auth/storeMember', {
          ...this.formattedSubmitData,
        })
        .then(() => {
          messageSuccess('已儲存')
          this.$FormMixinOnSubmitSuccess()
          this.$FormMixinInitTempSubmitData()
        })
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.formInfo {
  :global {
    .formInfo {
      @include unstyled;
    }
  }
}
</style>
